// scripts
import $ from 'jquery';
window.jQuery = $;
window.$ = $;

import 'jquery-validation';
import 'jquery-validation-unobtrusive';

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import moment from 'moment';
window.moment = moment;

import Cookies from 'cookies-js';
window.Cookies = Cookies;

import * as _ from 'lodash';
window._ = _;

import AnchorJS from 'anchor-js';
window.AnchorJS = AnchorJS;

import is from 'is-js';
window.is = is;

import Chart from 'chart.js/auto';
window.Chart = Chart;

import { CountUp } from 'countup.js';
window.CountUp = CountUp;

import '/lib/jquery-deparam/jquery-deparam.min.js';
import '/lib/font-awesome/js/all.min.js';
import '/lib/progress/kendo-ui/js/kendo.all.js';
import '/lib/progress/kendo-ui/js/kendo.aspnetmvc.js';
import './vendor/kendo-ui-license.js';

// styles
import '/lib/font-awesome/css/all.css';